// window.nextAegis?.infoAll(msg);

import { isServer } from '@tencent/web-base';
import { JSONObject } from './type-helper';

/**
 * 用于记录
 * ```js
 *    localStorage.getItem('DEV_LOGGER_KEY');
 * ```
 */
const DEV_LOGGER_KEY = 'DEV_LOGGER_KEY';
export const IS_PROD = process.env.NODE_ENV === 'production';

function aegisLog(data: string) {
  if (isServer || !IS_PROD) {
    return;
  }
  if (window.nextAegis) {
    window.nextAegis.infoAll(data);
  } else {
    localStorage.setItem(DEV_LOGGER_KEY, data);
  }
}

function getLogData(key: string, data: JSONObject, type = 'info'): string {
  if (type === 'error') {
    return `${key}[error]=${JSON.stringify(data)}`;
  }
  return `${key}=${JSON.stringify(data)}`;
}

/**
 * TAM数据上报
 */
export class TAMLogger {
  static info(key: string, data: JSONObject) {
    if (!IS_PROD) {
      console.log(key);
      console.log(data);
    }
    aegisLog(getLogData(key, data, 'info'));
  }
  static error(key: string, data: JSONObject) {
    if (!IS_PROD) {
      console.log(`${key}[error]`);
      console.log(data);
    }
    aegisLog(getLogData(key, data, 'error'));
  }
}
